export function getEnv() {
    // Implement your environment logic here
    // For example:
    if (window.location.hostname === 'localhost') {
        return 'development';
    } else if (window.location.hostname.includes('preprod')) {
        return 'preproduction';
    } else {
        return 'production';
    }
}